import './types'
import { FitMode, ScrollVideoOptions } from './types'
import toNumber from './utils/toNumber'
import { createOrUpdateScrollVideo, destroyScrollVideo } from './scroll-video'

const toFocusPoint = (input?: string): { x: number; y: number } | undefined => {
  if (!input) {
    return
  }
  const [x = 0.5, y = 0.5] = (input || '')
    .split(',')
    .map((x) => toNumber<number>(x, 50))
    .map((x) => x / 100)
  return {
    x,
    y
  }
}

export const optionsFromDom = (el: HTMLElement): ScrollVideoOptions => {
  const result: ScrollVideoOptions = {
    src: el.dataset.src || undefined,
    frames: toNumber<number | undefined>(el.dataset.frames, undefined),
    focusPoint: toFocusPoint(el.dataset.focusPoint),
    playbackSpeed: toNumber<number | undefined>(
      el.dataset.playbackSpeed,
      undefined
    ),
    webp: el.dataset.webp
      ? ['enabled', 'true'].includes(el.dataset.webp)
      : undefined,
    autoplay: el.dataset.autoplay
      ? ['enabled', 'true'].includes(el.dataset.autoplay)
      : undefined,
    autoplayDoneAt: toNumber<number | undefined>(
      el.dataset.autoplayDoneAt,
      undefined
    ),
    fit: el.dataset.fit as FitMode | undefined
  }
  for (const key in result) {
    if (result[key as keyof typeof result] === undefined) {
      delete result[key as keyof typeof result]
    }
  }
  const childWrap =
    el.firstElementChild &&
    el.firstElementChild.classList.contains('inner-wrap')
      ? el.firstElementChild
      : el

  result.contents = (Array.from(childWrap.children) as HTMLElement[])
    .filter((el) => el.classList.contains('scroll-video__contents'))
    .map((element) => {
      const { showAt, hideAt, fadeInDuration, fadeOutDuration } =
        element.dataset
      return {
        element,
        showAt: toNumber<number>(showAt, -Infinity),
        hideAt: toNumber<number>(hideAt, Infinity),
        fadeInDuration: toNumber<number>(fadeInDuration, 20),
        fadeOutDuration: toNumber<number>(fadeOutDuration, 20)
      }
    })

  return result
}

const scrollVideo = (
  elements: HTMLElement[],
  options: 'destroy' | ScrollVideoOptions = {}
): void => {
  elements.forEach((element) => {
    if (options === 'destroy') {
      destroyScrollVideo(element);
    } else {
      createOrUpdateScrollVideo(element, {
        ...optionsFromDom(element),
        ...options,
      });
    }
  });
};

const scrollVideoElements = Array.from(
  document.querySelectorAll('.scroll-video')
) as HTMLElement[];

scrollVideo(scrollVideoElements);
